
import React, { useState } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Dialog } from "@/components/ui/dialog";
import DangerWarning from "./danger-zone/DangerWarning";
import DeleteAccountDialog from "./danger-zone/DeleteAccountDialog";

const DangerZone = () => {
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);

  const handleDeleteClick = () => {
    // This function exists to handle any pre-dialog logic if needed in the future
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Danger Zone</CardTitle>
        <CardDescription>
          Permanently delete your account and all of your data.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Dialog open={isDeleteDialogOpen} onOpenChange={setIsDeleteDialogOpen}>
          <DangerWarning onDeleteClick={handleDeleteClick} />
          <DeleteAccountDialog 
            isOpen={isDeleteDialogOpen} 
            onOpenChange={setIsDeleteDialogOpen} 
          />
        </Dialog>
      </CardContent>
    </Card>
  );
};

export default DangerZone;
